import { defineMessages } from 'react-intl'

export default defineMessages({
  changeMe: {
    id: 'components.BankCardForm.changeMe',
    defaultMessage: '请修改',
    description: '请修改',
  },
  debitOnly: {
    id: 'components.BankCardForm.debitOnly',
    defaultMessage: '(Debit only)',
    description: '请修改',
  },
  listCardNumberLabel: {
    id: 'components.BankCardForm.listCardNumberLabel',
    defaultMessage: 'Card Number',
    description: 'Card Number: label',
  },
  listCardNumberPlaceholder: {
    id: 'components.BankCardForm.listCardNumberPlaceholder',
    defaultMessage: 'Enter your Card number',
    description: 'Card Number: Placeholder',
  },
  listExpireLabel: {
    id: 'components.BankCardForm.listExpireLabel',
    defaultMessage: 'Expiry Date',
    description: 'Expiry: label',
  },
  listExpirePlaceholder: {
    id: 'components.BankCardForm.listExpirePlaceholder',
    defaultMessage: 'MM/YY',
    description: 'Expiry: Placeholder',
  },
  listCVVLabel: {
    id: 'components.BankCardForm.listCVVLabel',
    defaultMessage: 'CVV',
    description: 'CVV: label',
  },
  listCVVPlaceholder: {
    id: 'components.BankCardForm.listCVVPlaceholder',
    defaultMessage: '3-digit CVV',
    description: 'CVV: Placeholder',
  },
  listCardHolderNameLabel: {
    id: 'components.BankCardForm.listCardHolderNameLabel',
    defaultMessage: 'Card Holder Name',
    description: 'Card Holder Name: label',
  },
  listCardHolderNamePlaceholder: {
    id: 'components.BankCardForm.listCardHolderNamePlaceholder',
    defaultMessage: 'Fill in name same as card account holder',
    description: 'Card Holder Name: Placeholder',
  },
  listEmailNameLabel: {
    id: 'routes.Payments.SessionPay.listEmailNameLabel',
    defaultMessage: 'Email Address <small class="gray">(optional)</small>',
    description: 'Email: label',
  },
  listEmailNamePlaceholder: {
    id: 'routes.Payments.SessionPay.listEmailNamePlaceholder',
    defaultMessage: 'Enter your Email Address',
    description: 'Email: Placeholder',
  },
  view: {
    id: 'components.BankCardForm.view',
    defaultMessage: 'Saved your card to wallet. I have read and agreed to ',
    description: 'View',
  },
  serviceAgreement: {
    id: 'components.BankCardForm.serviceAgreement',
    defaultMessage: 'Bank Card Agreement',
    description: 'Service Agreement',
  },
  noticeBox: {
    id: 'components.BankCardForm.noticeBox',
    defaultMessage: 'Notice Box',
    description: 'Notice Box',
  },
  noticeBoxDes: {
    id: 'components.BankCardForm.noticeBoxDes',
    defaultMessage: 'Optional contact method will be used to send you with the payment receipt for your personal safety record when you are facing disputes to appeal.',
    description: 'Notice Box Description',
  },
})
